@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  position: fixed;
  display: block;

  z-index: -1;
  overflow: auto;

  transform: var(--th,) var(--tv,);
}

:host(.open) {
  z-index: map.get($z-indices, 'popover');
}

.container {
  visibility: hidden;
  height: 0px;
}

.open {
  visibility: visible;
  height: auto;
  z-index: map.get($z-indices, 'popover');
}

:host(.transform-h-left) {
  --th: translateX(0);
}

:host(.transform-h-center) {
  --th: translateX(-50%);
}

:host(.transform-h-right) {
  --th: translateX(-100%);
}

:host(.transform-v-top) {
  --tv: translateY(0);
}

:host(.transform-v-center) {
  --tv: translateY(-50%);
}

:host(.transform-v-bottom) {
  --tv: translateY(-100%);
}
